import React from "react";

const ClientCallIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.52406 19.5622C6.85784 19.9722 6 19.4929 6 18.7105V6.28973C6 5.50729 6.85784 5.02803 7.52406 5.43798L17.6161 11.6484C18.2506 12.0389 18.2506 12.9613 17.6161 13.3518L7.52406 19.5622Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default ClientCallIcon;
